import React, { useState, useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography, TextField, IconButton, Button } from '@material-ui/core'
import Dropzone from '../atoms/Dropzone'
import { PictureAsPdf } from '@material-ui/icons'
import ConfigContext from '../../ConfigContext'

const useStyles = makeStyles(theme => ({
  previewImage: {
    width: '100px',
    objectFit: 'contain',
    marginBottom: '10px'
  },
  flexImageContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const InputFileLink: React.FC<{
  fileObject: File | null
  // s3対応
  // fileObject: { file: File | null; filename: string }
  inputHandler: (input: File) => void
  deleteHandler: () => void
  changeFilenameHandler: (filename: string) => void
}> = ({ fileObject, inputHandler, deleteHandler, changeFilenameHandler }) => {
  const classes = useStyles({})
  const [preview, setPreview] = useState<string>('')
  const [fileName, setFileName] = useState<string>('')
  const extension = new RegExp('\\.(pdf|jpg|gif|png)$', 'i')
  const config = useContext(ConfigContext)
  console.log(preview)
  console.log(fileName)

  useEffect(() => {
    if (fileObject instanceof File) {
      setFileName(fileObject.name)
      changeFilenameHandler(fileObject.name)
      setPreview(URL.createObjectURL(fileObject))
    }
    // s3対応
    // if (fileObject.file instanceof File) {
    //   console.log('useEffect')
    //   setFileName(fileObject.file.name)
    //   changeFilenameHandler(fileObject.file.name)
    //   setPreview(URL.createObjectURL(fileObject.file))
    // } else {
    //   setFileName(fileObject.filename)
    //   setPreview(fileObject.filename)
    // }
  }, [fileObject])

  return (
    <React.Fragment>
      <Box>
        <Typography variant="body2" paragraph>
          ※各種ファイルを登録すると、ファイルへ直接リンクすることができます。
        </Typography>
        <Typography variant="body2" paragraph>
          ※この設定を行うと「外部リンク設定」、「文字情報」の設定内容は無効になります。
        </Typography>
        <Typography variant="body2" paragraph>
          ※ファイル形式：PDF/JPG/GIF/PNG の登録が可能です。
        </Typography>
        <Box height="50%">
          <Box>
            <Dropzone
              dropHandler={files => {
                if (files.length) {
                  const acceptedEx = extension.test(files[0].name)
                  if (acceptedEx) {
                    inputHandler(files[0])
                  } else {
                    alert('ファイル形式は PDF/JPG/GIF/PNG で登録してください。')
                  }
                }
              }}
              accept="image/jpeg, image/png, image/gif, application/pdf"
            />
          </Box>

          {fileObject && (
            <React.Fragment>
              <Box display="flex">
                {preview && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    className={classes.flexImageContainer}
                  >
                    <img
                      className={classes.previewImage}
                      src={
                        fileName.toUpperCase().match(/\.(PDF)$/i)
                          ? `${config.serverHost}/static/icons/pdf.svg`
                          : preview
                      }
                      alt={
                        fileName.toUpperCase().match(/\.(PDF)$/i)
                          ? `${config.serverHost}/static/icons/pdf.svg`
                          : preview
                      }
                    />
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => deleteHandler()}
                    >
                      削除
                    </Button>
                  </Box>
                )}
              </Box>
            </React.Fragment>
          )}
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default InputFileLink
